export default async function CreateTopPlanApi(
  title,
  description,
  unitId,
  target,
  targetDate,
  scaleId,
  scaleUnitId,
  assignTo,
  performanceCycleId,
  planGroupId,
  canExceed,
  attributes,
  positionId,
  approverId,
  ehrmEvalId,
  ehrmGoalTypeId,
  ehrmGoalWeightage,
  cascadeFromSplitPlans,
  isPercentageUpdate,
  isNegativeScale
) {
  let res = "";
  try {
    console.log('CreateTopPlanApi - EHRM Parameters:', {
      ehrmEvalId,
      ehrmGoalTypeId,
      ehrmGoalWeightage
    });

    const body = {
      title: title,
      description: description || "",
      unitId: unitId,
      target: target,
      targetDate: targetDate || "",
      scaleId: scaleId,
      scaleUnitId: scaleUnitId,
      assignTo: assignTo,
      performanceCycleId: performanceCycleId,
      planGroupId: planGroupId,
      canExceed: canExceed,
      attributes: attributes,
      positionId: positionId,
      approverId: approverId,
    };

    // Only add EHRM fields if they have values
    if (ehrmEvalId !== undefined) {
      body.ehrmEvalId = ehrmEvalId;
    }
    if (ehrmGoalTypeId !== undefined) {
      body.ehrmGoalTypeId = ehrmGoalTypeId;
    }
    if (ehrmGoalWeightage !== undefined) {
      body.ehrmGoalWeightage = ehrmGoalWeightage;
    }

    // Add cascade from split plans field
    if (cascadeFromSplitPlans !== undefined) {
      body.cascadeFromSplitPlans = cascadeFromSplitPlans;
    }

    // Add percentage update fields
    if (isPercentageUpdate !== undefined) {
      body.isPercentageUpdate = isPercentageUpdate;
    }

    // Add negative scale field
    if (isNegativeScale !== undefined) {
      body.isNegativeScale = isNegativeScale;
    }

    console.log('CreateTopPlanApi - Request Body:', JSON.stringify(body, null, 2));

    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/top-level-plan`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error create plan: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
